import type { ComponentPropsWithoutRef } from 'react';
import type { CreatePayload } from '@atlaskit/link-create';
import type { EmbeddedContentModalProps, Page, Whiteboard } from '@atlassian/embedded-confluence';
import { entityKeys } from '@atlassian/link-create-confluence';

export const LINK_CREATE_DRAFT_STATUS = 'draft' as const;
export const LINK_CREATE_PUBLISH_STATUS = 'current' as const;

export const CONTENT_TYPE = {
	PAGE: 'page',
	WHITEBOARD: 'whiteboard',
} as const;

export const CONTENT_TYPE_TO_ENTITY_KEYS = {
	[CONTENT_TYPE.PAGE]: entityKeys.confluencePage,
	[CONTENT_TYPE.WHITEBOARD]: entityKeys.confluenceWhiteboard,
};

export interface CreateContentModalCoreProps {
	onCreate?: (payload: CreatePayload) => void;
	onFailure?: (error?: unknown) => void;
	onCancel?: () => void;
	onCloseComplete?: () => void;
	onOpenComplete?: () => void;
	onCreateBehavior?: typeof LINK_CREATE_DRAFT_STATUS | typeof LINK_CREATE_PUBLISH_STATUS;
	isQuickActionsListView?: boolean;
}

export interface CreateContentModalRuntimeProps extends CreateContentModalCoreProps {
	isOpen: boolean;
	contentType: (typeof CONTENT_TYPE)[keyof typeof CONTENT_TYPE];
}

export type CreateMenuContextType = {
	embeddedConfluenceSource: string;
	userHasConfluenceAccess: boolean;

	// @deprecated Use activePageData
	activePageUrl: string;
	setActivePageUrl: (_value: string) => void;

	accessStatus: string;
	setAccessStatus: (_value: string) => void;

	isCreateContentModalOpen: boolean;
	setIsCreateContentModalOpen: (_value: boolean) => void;

	isEpModalOpen: boolean;
	setIsEpModalOpen: (_value: boolean) => void;

	activePageData: CreatePayload;
	setActivePageData: (_value: CreatePayload) => void;

	createContentRuntimeProps: CreateContentModalRuntimeProps;
	setCreateContentRuntimeProps: (_value: CreateContentModalRuntimeProps) => void;

	isEpModalLoading: boolean;
	setIsEpModalLoading: (_value: boolean) => void;

	activeWhiteboardData: CreatePayload;
	setActiveWhiteboardData: (_value: CreatePayload) => void;

	isEmbeddedWhiteboardModalOpen: boolean;
	setEmbeddedWhiteboardModalOpen: (_value: boolean) => void;

	isCrossFlowModalOpen: boolean;
	setIsCrossFlowModalOpen: (_value: boolean) => void;

	isPublishModalEnabled: boolean;
	setIsPublishModalEnabled: (_value: boolean) => void;
};

export interface EmbeddedPageModalProps
	extends Omit<
			EmbeddedContentModalProps,
			'children' | 'openInConfluenceUrl' | 'onEmbeddedContentAction'
		>,
		ComponentPropsWithoutRef<typeof Page> {
	url: string;
	isLive?: boolean;
	onPageAction?: EmbeddedContentModalProps['onEmbeddedContentAction'];
}

export interface EmbeddedWhiteboardModalProps
	extends Omit<
			EmbeddedContentModalProps,
			'children' | 'openInConfluenceUrl' | 'onEmbeddedContentAction'
		>,
		ComponentPropsWithoutRef<typeof Whiteboard> {
	url: string;
	onEmbeddedContentAction?: EmbeddedContentModalProps['onEmbeddedContentAction'];
}
